import { render, staticRenderFns } from "./CommunityPickForm.vue?vue&type=template&id=a2838ba2&"
import script from "./CommunityPickForm.vue?vue&type=script&lang=js&"
export * from "./CommunityPickForm.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPickForm.vue?vue&type=style&index=0&id=a2838ba2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports